export default __webpack_public_path__ + "static/mobile-nav-e93c7626beddc688d5d8433666bb8d88.jpg";